import { Text } from "dripsy";
import AnimatedPressable from "./animated-pressable";
import * as React from "react";
import { Linking } from "react-native";

function Credits() {
  return (
    <AnimatedPressable
      onPress={() => Linking.openURL("https://webridge.nl")}
      animate={React.useMemo(
        () =>
          ({ hovered, pressed }) => {
            return {
              opacity: hovered || pressed ? 0.75 : 1,
            };
          },
        []
      )}
    >
      <Text sx={{ fontWeight: "400", opacity: 0.7, letterSpacing: 0.3, lineHeight: 20, py: "$2" }}>
        app ontwikkeld door <Text style={{ fontWeight: "600" }}>webRidge</Text>
      </Text>
    </AnimatedPressable>
  );
}

export default Credits;
